<script setup lang="ts">
interface Props{
  icon: string;
  badgeLabel?: string | number;
  disabled?: boolean;
  color?: string;
  loading?: boolean;
  tooltip?: unknown
}

const props = withDefaults(defineProps<Props>(), {
  badgeLabel: '',
  disabled: false,
  color: 'dark',
  loading: false,
  tooltip: undefined
});

const emits = defineEmits<{
  click: [];
}>();

function handleClick() {
  if (props.disabled || props.loading) {
    return;
  }

  emits('click');
}

</script>

<template>
  <IonButtons class="buttonsContainer">
    <IonButton
      v-tooltip.top="props.tooltip"
      fill="clear"
      :color="color"
      :disabled="props.disabled || props.loading"
      @click="handleClick()"
    >
      <IonSpinner v-if="loading" />
      <IonIcon
        v-else
        :class="icon"
      />
    </IonButton>
    <IonBadge
      v-if="badgeLabel"
      class="badgeAlignment"
    >
      {{ badgeLabel }}
    </IonBadge>
  </IonButtons>
</template>

<style scoped>

ion-button {
  height: 3rem;
  width: 3rem;
  --border-radius: 10rem !important;
}
ion-icon {
  font-size: 1.5rem;
}

.buttonsContainer {
  position: relative;
}

.badgeAlignment {
  --padding-bottom: 0.2rem;
  --padding-end: 0.5rem;
  --padding-start: 0.5rem;
  --padding-top: 0.2rem;
  border-radius: 10rem;
  font-size: 0.7rem;
  position: absolute;
  top: 0rem;
  right: 0rem;
}
</style>
